module.exports = __webpack_public_path__ + "Server-Default.AzureWebApp.64050f75c8895411be9f1b1bc72cc871.hashedasset.svg";